import { MapPin, ArrowRight, Hammer } from "lucide-react";

export default function Events({ events = [] }) {
  return (
    <section
      id="events"
      data-testid="events-section"
      className="relative py-20 md:py-32 bg-cream"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 items-end mb-14">
          <div className="md:col-span-7">
            <p className="overline mb-6">
              <Hammer size={11} strokeWidth={1.5} className="inline mr-2 -mt-1" />
              Our work
            </p>
            <h2 className="text-4xl md:text-5xl lg:text-6xl text-ink leading-tight">
              What eighteen years on the
              <br className="hidden md:block" />
              ground <em className="italic text-terracotta">actually</em> looks like.
            </h2>
          </div>
          <div className="md:col-span-4 md:col-start-9 text-graphite leading-relaxed">
            A short, honest list of what we've done — not what we plan to do.
          </div>
        </div>

        <ul className="border-t border-line">
          {events.map((e, idx) => (
            <li
              key={e.id}
              data-testid={`event-row-${e.id}`}
              className="group grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 py-8 md:py-10 border-b border-line transition-colors hover:bg-sand/60 px-2 md:px-4 -mx-2 md:-mx-4"
            >
              <div className="md:col-span-2 flex md:flex-col gap-3 md:gap-1">
                <p className="font-serif text-3xl md:text-4xl text-ink leading-none">
                  {String(idx + 1).padStart(2, "0")}
                </p>
                <div className="overline self-end md:self-start">
                  {e.date}
                </div>
              </div>
              <div className="md:col-span-7">
                <h3 className="text-2xl md:text-3xl text-ink leading-snug mb-2 group-hover:text-terracotta transition-colors">
                  {e.title}
                </h3>
                <p className="text-graphite mb-3 leading-relaxed">
                  {e.description}
                </p>
                <div className="overline flex items-center gap-2 text-forest">
                  <MapPin size={12} strokeWidth={1.5} />
                  {e.location}
                </div>
              </div>
              <div className="md:col-span-3 flex md:justify-end items-start">
                <a
                  href="#contact"
                  data-testid={`event-cta-${e.id}`}
                  className="inline-flex items-center gap-2 border border-ink hover:border-terracotta hover:text-terracotta text-ink px-6 py-3 transition-colors"
                >
                  {e.cta_label}
                  <ArrowRight
                    size={16}
                    className="transition-transform group-hover:translate-x-1"
                  />
                </a>
              </div>
            </li>
          ))}
        </ul>

        {/* Featured field photo */}
        <figure
          data-testid="work-feature-photo"
          className="mt-16 md:mt-20 relative overflow-hidden grain"
        >
          <img
            src="/imgs/ngo-river-cleaning.jpg"
            alt="JRSDWA volunteers cleaning the riverbank on a foggy winter morning"
            className="w-full h-[480px] md:h-[620px] object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-ink/70 via-ink/10 to-transparent" />
          <figcaption className="absolute left-0 right-0 bottom-0 p-6 md:p-10">
            <div className="max-w-2xl bg-cream/95 backdrop-blur-sm p-6 md:p-8">
              <p className="overline mb-3">Field photograph · Winter 2024</p>
              <h3 className="font-serif text-2xl md:text-3xl text-ink leading-snug mb-2">
                Riverbank Clean-up Drive
              </h3>
              <p className="text-graphite leading-relaxed">
                A volunteer brigade at first light, clearing plastic and ritual
                waste from the river edge — one of our recurring weekend
                sanitation drives that doubles as an environmental-awareness
                workshop for the neighbourhood.
              </p>
            </div>
          </figcaption>
        </figure>
      </div>
    </section>
  );
}
